<nz-form-item>
  <nz-form-label [nzSpan]="10" [nzNoColon]="true">
    {{parameters[0].Label | locale}}
  </nz-form-label>
  <app-param-select [nzSpan]="14" *ngIf="parameters[0].Type == 7" nz-col [parameter]="parameters[0]" [dashboardParams]="dashboardParams" [dashboardId]="dashboardId" [dashboardParamNames]="dashboardParamNames">
  </app-param-select>
  <app-param-date [nzSpan]="14" *ngIf="parameters[0].Type == 0" nz-col [parameter]="parameters[0]" [dashboardParams]="dashboardParams" [dashboardId]="dashboardId" [dashboardParamNames]="dashboardParamNames">
  </app-param-date>
</nz-form-item>
